import { InfoAction } from "../../actions/components/InfoAction";

export enum AppInfoType {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success",
}

export interface InfoState {
  severity: AppInfoType;
  infoMessage: string;
  open: boolean;
  duration:number;
}

const initialState = {
  severity: AppInfoType.error,
  infoMessage: "",
  open: false,
  duration:2000
};

export function InfoReducer(
  state: InfoState = initialState,
  action: InfoAction
): InfoState {
  switch (action.type) {
    case "INFO_SUCCESS":
      return {
        ...state,
        severity: AppInfoType.success,
        infoMessage: action.payload[0],
        open: true,
        duration:action.payload[1]
      };
    case "INFO_ERROR":
      return {
        ...state,
        severity: AppInfoType.error,
        infoMessage: action.payload[0],
        open: true,
        duration:action.payload[1]
      };
    case "INFO_WARN":
      return {
        ...state,
        severity: AppInfoType.warning,
        infoMessage: action.payload[0],
        open: true,
        duration:action.payload[1]
      };
    case "ON_CLOSE_INFO_DISPLAY":
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}
